import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  findFoldersByUser,
  createFolder,
  deleteFolder,
} from "../db/folderRepository";

export function useFolderList(userId: string | null) {
  return useQuery({
    queryKey: ["folders", userId],
    queryFn: () => findFoldersByUser(userId!),
    enabled: !!userId,
  });
}

export function useCreateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      userId,
      name,
      color,
    }: {
      userId: string;
      name: string;
      color: string;
    }) => createFolder(userId, name, color),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["folders"] });
    },
  });
}

export function useDeleteFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (folderId: string) => deleteFolder(folderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["folders"] });
      queryClient.invalidateQueries({ queryKey: ["pdfs"] });
    },
  });
}
